import React from 'react';
import { Wrench, BadgeCheck, ShieldCheck } from 'lucide-react';

/**
 * CoreTrustBadges, the three real-world credentials the business leads with.
 * Designed to sit prominently next to booking / inquiry CTAs (header band,
 * mobile drawer, About page, sidebar blocks). STRICTLY ADDITIVE.
 */
const BADGES = [
  { icon: Wrench, label: 'Hundreds of Repairs', sub: 'Completed' },
  { icon: BadgeCheck, label: 'Apple Independent Repair Provider', sub: 'AIRP Certified' },
  { icon: ShieldCheck, label: '6-Month Repair Protection Plan', sub: 'Available on every repair' },
];

export const CoreTrustBadges = ({ dark = false, compact = false, className = '' }) => {
  const card = dark
    ? 'bg-white/[0.05] border-white/10'
    : 'bg-emerald-50 border-emerald-200/70';
  const iconWrap = dark
    ? 'bg-emerald-500/15 border-emerald-400/30'
    : 'bg-emerald-100 border-emerald-300/60';
  const iconColor = dark ? 'text-emerald-400' : 'text-emerald-600';
  const labelColor = dark ? 'text-white' : 'text-slate-900';
  const subColor = dark ? 'text-slate-400' : 'text-slate-500';

  return (
    <div
      data-testid="core-trust-badges"
      className={`grid grid-cols-1 sm:grid-cols-3 gap-2.5 ${className}`}
    >
      {BADGES.map((b, i) => {
        const Icon = b.icon;
        return (
          <div
            key={i}
            data-testid={`core-trust-badge-${i}`}
            className={`flex items-center gap-2.5 rounded-xl border px-3 ${compact ? 'py-2' : 'py-2.5'} ${card}`}
          >
            <div className={`shrink-0 w-8 h-8 rounded-lg border flex items-center justify-center ${iconWrap}`}>
              <Icon className={`w-4 h-4 ${iconColor}`} />
            </div>
            <div className="min-w-0">
              <div className={`text-xs font-bold leading-tight ${labelColor}`}>{b.label}</div>
              <div className={`text-[10px] leading-tight ${subColor}`}>{b.sub}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CoreTrustBadges;
